import {makeAutoObservable, runInAction} from "mobx";
import {RandomId} from "../util";

export class ToastStore {
    items = [];
    timers = new Map();
    position = "top-right";  // "top-left" | "bottom-left" | "bottom-right"
    max = 4;
    defaultDuration = 4500;

    constructor() {
        makeAutoObservable(this);
    }

    push(partial) {
        const _id = partial.id || RandomId();
        const duration = partial.duration != null ? partial.duration : this.defaultDuration;
        const canClose = partial.canClose == null ? false : partial.canClose;
        const item = {
            id: _id,
            createdAt: Date.now(),
            ...partial,
            canClose,
            duration,
        };

        // de-dup por 2s
        const dup = this.items.find(
            it => it.variant === item.variant &&
                it.message === item.message &&
                Date.now() - it.createdAt < 2000
        );
        if (dup) return dup.id;

        runInAction(() => {
            this.items.unshift(item);
            if (this.items.length > this.max) this.items = this.items.slice(0, this.max);
        });

        if (duration > 0) {
            const t = window.setTimeout(() => this.close(_id), duration);
            this.timers.set(_id, t);
        }
        return _id;
    }

    close(id) {
        const t = this.timers.get(id);
        if (t) {
            window.clearTimeout(t);
            this.timers.delete(id);
        }
        const it = this.items.find(x => x.id === id);
        runInAction(() => {
            this.items = this.items.filter(x => x.id !== id);
        });
        it?.onClose && it.onClose();
    }

    clear() {
        this.items.forEach(it => it.onClose && it.onClose());
        this.items = [];
        this.timers.forEach(t => window.clearTimeout(t));
        this.timers.clear();
    }

    configure(opts = {}) {
        if (opts.position) this.position = opts.position;
        if (Number.isFinite(opts.max)) this.max = opts.max;
        if (Number.isFinite(opts.defaultDuration)) this.defaultDuration = opts.defaultDuration;
    }
}